import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import cls from "./BurgerMenu.module.css";

interface BurgerMenuProps {
  sections: { id: string; title?: string }[];
  current: number;
  scrollToSection: (index: number) => void;
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({ sections, current, scrollToSection, isOpen, setIsOpen }) => {
  const { i18n, t } = useTranslation();

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleNavClick = (index: number) => {
    scrollToSection(index);
    setIsOpen(false);
  };

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const isActive = (lng: string) => i18n.language?.startsWith(lng);

  return (
    <>
      <button 
        className={`${cls.burgerBtn} ${isOpen ? cls.active : ""}`} 
        onClick={toggleMenu}
        aria-label="Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            <motion.div
              className={cls.overlay}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={toggleMenu}
            />

            <motion.div
              className={cls.sidebar}
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "spring", damping: 25, stiffness: 120 }}
            >
              <nav className={cls.nav}>
                <ul className={cls.navList}>
                  {sections.map((section, index) => (
                    <motion.li 
                      key={section.id}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ delay: 0.05 * index }}
                    >
                      <button
                        className={`${cls.navLink} ${current === index ? cls.activeLink : ""}`}
                        onClick={() => handleNavClick(index)}
                      >
                        <span className={cls.navNumber}>0{index + 1}</span>
                        {t(`menu.${section.id}`)}
                      </button>
                    </motion.li>
                  ))}
                </ul>
              </nav>

              <div className={cls.langSwitcher}>
                <button 
                  className={isActive('kk') ? cls.activeLang : ""} 
                  onClick={() => changeLanguage('kk')}
                >
                  KZ
                </button>
                <span className={cls.divider}>|</span>
                <button 
                  className={isActive('ru') ? cls.activeLang : ""} 
                  onClick={() => changeLanguage('ru')}
                >
                  RU
                </button>
                <span className={cls.divider}>|</span>
                <button 
                  className={isActive('en') ? cls.activeLang : ""} 
                  onClick={() => changeLanguage('en')}
                >
                  EN
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default BurgerMenu;